import { createSelector } from 'reselect';

export const getCoreConfigLoading = createSelector(
  state => state.core?.isLoading,
  isLoading => isLoading
);

export const getPhoneNumber = createSelector(
  state => state.core?.phoneNumber,
  phoneNumber => phoneNumber
);

export const getUserLoggedInStatus = createSelector(
  state => state.core?.isLoggedIn,
  isLoggedIn => isLoggedIn
);

export const getUserEmail = createSelector(
  state => state.core?.email,
  email => email
);

export const getUserImpersonated = createSelector(
  state => state.core?.isUserBeingImpersonated,
  isUserBeingImpersonated => isUserBeingImpersonated
);

export const getVehicleLock = createSelector(
  state => state.dashboard?.vehicleLock,
  vehicleLock => vehicleLock
);

export const getVehicle = createSelector(
  state => state.dashboard?.vehicle,
  vehicle => vehicle
);
